import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import useFetchPaymentLinkAssociatedPaymentId from './hooks/useFetchPaymentLinkAssociatedPaymentId';
import { COMMERCE_PAYMENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
const PaymentLinkViewPaymentButton = ({
  objectId,
  onPreview,
  hasScope,
  sourceObjectId,
  sourceObjectTypeId
}) => {
  const {
    associatedPaymentId,
    canView
  } = useFetchPaymentLinkAssociatedPaymentId(objectId, hasScope, sourceObjectId, sourceObjectTypeId);
  if (!associatedPaymentId) {
    return null;
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardAssociatedObjects.chicklet.PaymentLinkViewPaymentButton.noViewAccess"
    }),
    disabled: canView,
    placement: "left",
    children: /*#__PURE__*/_jsx(Link, {
      onClick: () => {
        if (onPreview) onPreview({
          objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
          objectId: associatedPaymentId
        });
      },
      disabled: !canView,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.chicklet.PaymentLinkViewPaymentButton.viewPayment"
      })
    })
  });
};
export default PaymentLinkViewPaymentButton;